import React from 'react';
import { useLocation } from 'react-router-dom';
import SubscriptionPlansPicker from '../../Shared/SubscriptionPlansPicker';

export default function SignupSelectPlan() {
  const location = useLocation();
  const role = location.state?.role;

  return (
    <SubscriptionPlansPicker requireAuthRedirect signupRole={role} />
  );
}
